// Javascript hints
// Variables included in file scope, etc


/**
 * @name products
 * @type {object}
 */

/**
 * @name paypal_env
 * @type {string}
 */

/**
 * @name ajax_order_create_url
 * @type {string}
 */

/**
 * @name client_token_get_url
 * @type {string}
 */

/**
 * @name customer_support_email
 * @type {string}
 */

/**
 * @name close_super_crazy
 * @type {boolean}
 */

// Libraries
// we bring them into the global namespace for console usage and debugging

global.$ = require('jquery');
require('block-ui');
require('./smoothscroll');

// knockout
global.ko = require('knockout');
require('knockout-pre-rendered');
require('knockout.validation');
// apply validation rules
require('./validation-rules')(ko);

// locutus
global.print_r = require('locutus/php/var/print_r');
global.sprintf = require('locutus/php/strings/sprintf');
global.number_format = require('locutus/php/strings/number_format')

// Local
var view_models = require('./view-models');
var order_form_selector = '#order-form';
// configure payment fuctions
var hosted_fields_styles_object = {
    'input': {
        'font-size': '16pt',
        'color': '#3A3A3A',
        'font-family': 'monospace',
        'text-align': 'center'
    },
    '.number': {},
    '.valid': {
        'color': 'green'
    }
};
var hosted_fields_number_selector = '#card-number';
var hosted_fields_cvv_selector = '#cvv';
var hosted_fields_exp_selector = '#expiration-date';
var hosted_fields_post_code_selector = '#postal-code';
var paypal_button_styles_object = {
    size: 'responsive',
    color: 'gold',
    shape: 'pill',
    label: 'checkout'
};
var paypal_button_selector = '#paypal-button';
var pppin4_selector = '#pppin4-button';


vm = new view_models.OrderViewModel(order_form_selector,
    products,
    customer_support_email,
    client_token_get_url,
    ajax_order_create_url,
    paypal_env,
    hosted_fields_styles_object,
    hosted_fields_number_selector,
    hosted_fields_cvv_selector,
    hosted_fields_exp_selector,
    hosted_fields_post_code_selector,
    paypal_button_selector,
    paypal_button_styles_object,
    pppin4_selector);

$(document).ready(function () {
    ko.validation.init({insertMessages: false});
    // VIEW MODEL INITIALIZATION
    ko.applyBindings(vm);
    // the way these are initialized, this is the only way to avoid triggering
    // validation immediately
    vm.purchaser.country.isModified(false);
    vm.recipient.country.isModified(false);
    vm.order_type($('[name=order_type]:first').val());

    if (close_super_crazy) {
        $("#id\\.order_type_2").attr('disabled', true);
        var ex_text = $("#id\\.order_type_2").parent().find("span").text();
        $("#id\\.order_type_2").parent().find("span").text(ex_text + ' (SOLD OUT)');
        $("#id\\.order_type_2").parent().find("span").css('color', 'grey');
    }

});
